import { IonButton } from "@ionic/react";
import React from "react";
import "./StyledButton.css";

export default function StyledButton(props) {
  return <IonButton {...props} />;
}
